import Head from 'next/head';

import { DynamicObject } from '../../../utils/commonTypes';
import { getOGTitle } from '../../../utils/OGTags';

interface ComponentProps {
  displayLanguage: string;
  assetTitle: string;
  title: string;
  description: string;
  ogTags: DynamicObject;
}

const OGTags = ({
  assetTitle = '',
  title = '',
  description = '',
  displayLanguage,
  ogTags
}: ComponentProps) => {
  const {
    ogImage = '',
    ogType = '',
    ogSiteName = '',
    ogUrl = '',
    fbId = '',
    twitterCard = '',
    twitterSite = '',
    twitterImage = ''
  } = ogTags || {};

  const ogTitle = getOGTitle(ogUrl, displayLanguage, title);
  return (
    <>
      <Head>
        <meta property="og:title" content={assetTitle || ogTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:type" content={ogType} />
        <meta property="og:site_name" content={ogSiteName} />
        <meta property="og:url" content={ogUrl} />
        <meta property="fb:app_id" content={fbId} />
        <meta name="twitter:card" content={twitterCard} />
        <meta name="twitter:site" content={twitterSite} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={twitterImage} />
        <meta name="twitter:url" content={ogUrl} />
        <meta name="twitter:app:country" content="IN" />
        <meta name="twitter:app:name:iphone" content="ZEE5" />
        <meta name="twitter:app:id:iphone" content="743691886" />
        <meta name="twitter:app:url:iphone" content={ogUrl} />
        <meta name="twitter:app:name:googleplay" content="ZEE5" />
        <meta name="twitter:app:id:googleplay" content="com.graymatrix.did" />
        <meta name="twitter:app:url:googleplay" content={ogUrl} />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="200" />
        <meta property="al:ios:url" content={ogUrl} />
        <meta property="al:ios:app_store_id" content="743691886" />
        <meta property="al:ios:app_name" content="ZEE5" />
        <meta property="al:android:url" content={ogUrl} />
        <meta property="al:android:package" content="com.graymatrix.did" />
        <meta property="al:android:app_name" content="ZEE5" />
      </Head>
    </>
  );
};

export default OGTags;
